import { select, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import { isFeatureEnabledFromCookie } from 'yoda-core-components/lib/helpers/Utils/Utils';
import siteAnalyticsAction from 'yoda-site-components/lib/actions/AnalyticsAction';
import * as newShippingAction from '../actions/NewShippingAction';
import { CLEAR_GAV_ERROR, SET_GAV_ERROR } from '../actionTypes/NewShippingActionTypes';

const contextSelector = (state) => state.context;
const googleStandardizationNotRequiredSelector = (state) =>
    state.newShipping.shipToHomeInfo?.xGoogleStandardizationNotRequired || false;
const shipToHomeInfoSelector = (state) => state.newShipping.shipToHomeInfo;
const userAddressListSelector = (state) => state.newShipping.shipToHomeInfo.userAddressList;
const newShippingSelector = (state) => state.newShipping;

export function* isGoogleAddressValidationEnabled() {
    const context = yield select(contextSelector);
    const enableGoogleAddressValidation = get(
        context,
        'featureFlags.enableGoogleAddressValidation',
        false
    );
    return isFeatureEnabledFromCookie('enableGAV') || enableGoogleAddressValidation;
}

export function* getGoogleAddressVerificationRequired() {
    const isGAVEnabled = yield call(isGoogleAddressValidationEnabled);
    const xGoogleStandardizationNotRequired = yield select(
        googleStandardizationNotRequiredSelector
    );
    return isGAVEnabled && !xGoogleStandardizationNotRequired;
}

/** onload render subpremise error message and do hard stop */
export function* handleSubPremiseValidation(orderDetailsInfo, isUserLoggedIn) {
    const shipToHomeInfo = yield select(shipToHomeInfoSelector);
    const exceptions = orderDetailsInfo?.data?.status?.exceptions;

    const subPremiseException = find(exceptions, {
        errorCode: 'SRV_CUSTOMER_STD_SUBPREMISE_INVALID',
    });
    const doubleCheckException = find(exceptions, {
        errorCode: 'SRV_CUSTOMER_STD_ADDRESS_INVALID',
    });

    const exception = subPremiseException || doubleCheckException;
    const errorHandlerInfo = {
        context: 'ADDRESS',
        doNotClearToken: true,
        errorComponent: 'SHIPPING_SECTION',
    };
    if (!isEmpty(exception)) {
        errorHandlerInfo.errorCode = exception.errorCode;
        errorHandlerInfo.errorMessage = exception.errorMessage;
        yield put(newShippingAction.setNewShippingAddressSubpremiseInvalid(!!subPremiseException));
        yield put({ type: SET_GAV_ERROR, errorHandlerInfo });
        yield put(
            siteAnalyticsAction.triggerFormError([{ errorDescription: exception.errorMessage }])
        );
    } else if (shipToHomeInfo?.subPremiseInvalid) {
        errorHandlerInfo.errorCode = 'SET_NEW_SHIPPING_ADDRESS_SUBPREMISE_INVALID';
        errorHandlerInfo.errorMessage =
            "Apartment, suite, or floor number couldn't be verified. Please correct to continue.";
        if (isUserLoggedIn || shipToHomeInfo?.showAddShippingAddressForm) {
            yield put({ type: SET_GAV_ERROR, errorHandlerInfo });
        }
    } else {
        yield put(newShippingAction.setNewShippingAddressSubpremiseInvalid(false));
        yield put({ type: CLEAR_GAV_ERROR, errorHandlerInfo });
    }
}

/** If no address is added to order, re-adds the selected address to order */
export function* reapplySelectedAddressIfMissing(
    cartDetailsResponse,
    isUserLoggedIn,
    changeShippingAddressToOrder
) {
    const exceptions = cartDetailsResponse?.data?.status?.exceptions;
    const newShipping = yield select(newShippingSelector);

    const addressNotFound = find(exceptions, {
        errorCode: 'SRV_ORDER_ADDRESS_NOT_FOUND',
    });
    const isDoubleCheckError =
        newShipping?.shipToHomeInfo?.gavError?.errorCode === 'SRV_CUSTOMER_STD_ADDRESS_INVALID';
    if (
        (addressNotFound || isDoubleCheckError) &&
        isUserLoggedIn &&
        newShipping.shippingType === 'HOME'
    ) {
        const userAddressList = yield select(userAddressListSelector);
        const selectedAddress = find(userAddressList, { selected: true });
        if (selectedAddress) {
            if (addressNotFound)
                console.log('*** In STH Address is missing, reapplying the selected Address ****');
            if (isDoubleCheckError)
                console.log(
                    '*** In STH Address added address is double check error, on continue adding to order ****'
                );

            const action = {
                address: selectedAddress,
                isFromUnavailableAddressSelection: true,
                skipGAVValidation: true,
            };
            const isAddressUpdated = yield call(changeShippingAddressToOrder, action);
            return isAddressUpdated;
        }
    }
    return true;
}
